import { Fragment } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

export default function ProgressTracker({ currentStage, totalStages, onStageSelect, progress }) {
  const stages = Array.from({ length: totalStages }, (_, i) => i + 1);

  return (
    <nav aria-label="Progress" className="mb-8">
      <ol className="flex items-center">
        {stages.map((stage, index) => {
          const isComplete = stage < currentStage;
          const isCurrent = stage === currentStage;
          const stageProgress = progress?.stages?.[stage]?.progress || 0;
          
          return (
            <Fragment key={stage}>
              {index !== 0 && (
                <li className="relative flex-1">
                  <div className="absolute inset-0 flex items-center" aria-hidden="true">
                    <div className={`h-0.5 w-full ${isComplete ? 'bg-blue-600' : 'bg-gray-200'}`} />
                  </div>
                </li>
              )}
              <li className="relative flex-1">
                <button
                  onClick={() => onStageSelect && onStageSelect(stage)}
                  className={`group relative flex h-8 w-8 items-center justify-center rounded-full ${
                    isComplete ? 'bg-blue-600 hover:bg-blue-700' : 
                    isCurrent ? 'bg-white border-2 border-blue-600' : 
                    'bg-white border-2 border-gray-300 hover:border-gray-400'
                  }`}
                  aria-current={isCurrent ? 'step' : undefined}
                >
                  {isComplete ? (
                    <CheckCircleIcon className="h-5 w-5 text-white" aria-hidden="true" />
                  ) : (
                    <span className={`text-sm font-medium ${
                      isCurrent ? 'text-blue-600' : 'text-gray-500 group-hover:text-gray-900'
                    }`}>
                      {stage}
                    </span>
                  )}
                  <span className="sr-only">
                    {isComplete ? 'Completed' : isCurrent ? 'Current' : ''} Stage {stage}
                  </span>
                </button>
                {isCurrent && stageProgress > 0 && (
                  <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 text-xs text-blue-600 font-medium">
                    {stageProgress}% Complete
                  </div>
                )}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
